export default {
  title: 'Create SKU',
  skuName: 'SKU Name',
  description: 'Description',
  deviceType: 'Device Model',
  addSkuSuccess: 'Adding sku success',
  addSkuError: 'Adding sku error',
  productFamily: 'Product Family',
};
